import { render, staticRenderFns } from "./materialDetail.vue?vue&type=template&id=8f223048&scoped=true&"
import script from "./materialDetail.vue?vue&type=script&lang=js&"
export * from "./materialDetail.vue?vue&type=script&lang=js&"
import style0 from "./materialDetail.vue?vue&type=style&index=0&id=8f223048&lang=scss&scoped=true&"
import style1 from "./materialDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f223048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f223048')) {
      api.createRecord('8f223048', component.options)
    } else {
      api.reload('8f223048', component.options)
    }
    module.hot.accept("./materialDetail.vue?vue&type=template&id=8f223048&scoped=true&", function () {
      api.rerender('8f223048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/materialDetail.vue"
export default component.exports